<template>
    <div
        class="content-end mt-4 md:flex items-center"
        data-testid="widget-footer"
        :class="[appearanceFooter ? `${appearanceFooter}` : '']"
    >
        <div class="flex-grow mr-6">
            <p
                v-if="text"
                class="text-slate-600 leading-6 whitespace-pre-line"
                v-text="text"
            ></p>
        </div>
        <div
            v-if="buttonLink && buttonText"
            class="text-center margin-top mr-0"
        >
            <BtnCta
                :href="buttonLink"
                :target="buttonTarget"
                class="whitespace-nowrap w-full"
                size="lg"
                :label="buttonText"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'WidgetFooter',
    props: {
        text: {
            type: String,
            default: '',
        },
        appearanceFooter: {
            type: String,
            default: '',
        },
        buttonLink: {
            type: String,
            default: '',
        },
        buttonTarget: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.whitespace-nowrap {
    white-space: nowrap;
}

.margin-top {
    margin-top: 16px;
}

@screen md {
    .margin-top {
        margin-top: auto;
    }
}
</style>
